import React, { useState } from 'react';
import SessionConfigManager from '../components/Settings/SessionConfigManager';
import SchoolSettings from '../components/Settings/SchoolSettings';
import './Settings.css';

const Settings: React.FC = () => {
  const [activeTab, setActiveTab] = useState('session-config');

  const tabs = [
    { id: 'session-config', label: 'Session Configuration', icon: '⏰' },
    { id: 'general', label: 'General Settings', icon: '⚙️' },
    { id: 'notifications', label: 'Notifications', icon: '🔔' },
  ];

  return (
    <div className="settings-page">
      <div className="settings-header">
        <h1>Settings</h1>
        <p>Manage your application settings and configurations</p>
      </div>

      <div className="settings-content">
        <div className="settings-tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`settings-tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className="tab-icon">{tab.icon}</span>
              <span className="tab-label">{tab.label}</span>
            </button>
          ))}
        </div>

        <div className="settings-panel">
          {activeTab === 'session-config' && <SessionConfigManager />}
          {activeTab === 'general' && <SchoolSettings />}
          {activeTab === 'notifications' && (
            <div className="settings-section">
              <h3>Notification Settings</h3>
              <p>Notification preferences will be available here.</p>
            </div>
          )}
        </div>
      </div>


    </div>
  );
};

export default Settings;